var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepresentada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.919 3.86093L9.844 6.44993V4.44993C9.84505 4.32348 9.81182 4.19911 9.74785 4.09003C9.68388 3.98095 9.59156 3.89124 9.48069 3.83042C9.36982 3.7696 9.24455 3.73995 9.11819 3.74462C8.99182 3.74929 8.86908 3.7881 8.763 3.85693L4.688 6.44993V0.70293C4.688 0.517278 4.61425 0.33923 4.48297 0.207955C4.3517 0.0766794 4.17365 0.00292969 3.988 0.00292969H0.7C0.514348 0.00292969 0.336301 0.0766794 0.205025 0.207955C0.0737498 0.33923 0 0.517278 0 0.70293L0 12.4219C0 12.6076 0.0737498 12.7856 0.205025 12.9169C0.336301 13.0482 0.514348 13.1219 0.7 13.1219H14.3C14.4857 13.1219 14.6637 13.0482 14.795 12.9169C14.9262 12.7856 15 12.6076 15 12.4219V4.44993C15.0003 4.32382 14.9666 4.19997 14.9023 4.09146C14.838 3.98295 14.7457 3.89382 14.6349 3.83348C14.5242 3.77314 14.3992 3.74384 14.2732 3.74867C14.1472 3.7535 14.0248 3.79229 13.919 3.86093V3.86093Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepresentada);
export default __webpack_public_path__ + "static/media/representada.c108f02a28c55d1e0458e1f2b2d168f0.svg";
export { ForwardRef as ReactComponent };